import { useGetPipeSeries } from "@imi/api-client/index.js";
import { useTranslation } from "react-i18next";
import { useQueryState } from "./queries/useQueryState";

export function useCustomPipeSeries() {
  const { t } = useTranslation("settings", { keyPrefix: "pipeSeries.add" });
  return useQueryState(useGetPipeSeries(), t("errors.fetchUnknown"));
}
